import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { BrandPriceList } from "@NA/Store/Data/ADIRequestPriceListState";
import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";

export interface RequestPriceListParameter extends ApiParameter {
    brandsSelected: string;
}

export interface RequestPriceListModel {
    brandsSelected: string;
}

type HandlerType = CustomApiHandler<RequestPriceListParameter, RequestPriceListModel>;

export const DispatchRequestPriceList: HandlerType = (props: any) => {
    props.dispatch({
        type:"Common/RequestPriceListRadioButton",
        result: props.parameter.brandsSelected,
    });
};





export const chain = [DispatchRequestPriceList];

const brandRadioPriceList = createHandlerChainRunnerOptionalParameter(
    chain,
    {
        brandsSelected: "Specific Brands",
    },
    "brandRadioPriceList",
);
export default brandRadioPriceList;
